import { render, staticRenderFns } from "./ChevronRightLastRounded.vue?vue&type=template&id=ec2a0a24&"
import script from "./ChevronRightLastRounded.vue?vue&type=script&lang=js&"
export * from "./ChevronRightLastRounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports